import React, { useState } from 'react';
import './AnnualPercentageDisclaimer.scss';
import { ANNUAL_PERCENTAGE_DISCLAIMER } from '../../../redux/modules/modals/modals.module';
import Checkbox from '../../Shared/Checkbox/Checkbox';
import { Button } from '../../Shared/Button';
const AnnualPercentageDisclaimer = ({ closeModal }) => {
  const [checkedBox, setCheckedBox] = useState(false);
  return (
    <div>
      <div className={'header'}>Annual Percentage Disclaimer</div>
      <p className={'body'}>
        The percentage that you elect will be evenly divided by the number of
        occurrences you have scheduled. For example, if you choose to distribute
        12% on the first of each month, we will distribute 1% of the account
        balance on each of the 12 occurrences.
      </p>
      <div className={'body'}>
        <Checkbox
          inline
          ariaLabel="Manual Annual Percentage Checkbox"
          checked={checkedBox}
          id="checkbox_annual_percentage"
          name="manualAnnualPercentage"
          onClick={() => setCheckedBox(!checkedBox)}
        />
        I acknowledge that the amount I enter will be taken on an annual
        percentage basis.
      </div>
      <Button
        buttonType="primary"
        className="btn-trp-primary RI2020-continue-button"
        id="ri2020-income-tax-withholding-disclosure"
        disabled={!checkedBox}
        onClick={() => closeModal(ANNUAL_PERCENTAGE_DISCLAIMER)}
      >
        Continue
      </Button>
    </div>
  );
};

export default AnnualPercentageDisclaimer;
